import React from 'react';
import styles from './Loading.module.css';

const Loading = ({ message = 'Загрузка...', size = 'medium', fullPage = false }) => {
  const sizeClass = styles[size] || styles.medium;

  return (
    <div className={`${styles.loadingContainer} ${fullPage ? styles.fullPage : ''}`}>
      <div className={`${styles.spinner} ${sizeClass}`} />
      {message && <p className={styles.loadingMessage}>{message}</p>}
    </div>
  );
};

export default Loading;
